import ReactDOM from 'react-dom';
import App from './App';
import { TrelloPowerUpContextProvider } from '@powerupsclub/trello';
import { PaymentsContextProvider } from '@powerupsclub/payments';
import { LoggerErrorBoundary } from '@powerupsclub/logger';

import '@atlaskit/css-reset';
import './index.scss';

import { setGlobalTheme } from '@atlaskit/tokens';

setGlobalTheme({
  colorMode: 'auto',
  light: 'light',
  dark: 'dark',
  spacing: 'spacing',
});

const trelloAPIKey = '70891d358173293bcb5e11ca7cb59452';

ReactDOM.render(
  <LoggerErrorBoundary powerUpKey="boardChat">
    <TrelloPowerUpContextProvider
      appKey={trelloAPIKey}
      appName="Board Chat"
      powerUpKey="boardChat"
      localization={{
        defaultLocale: 'en',
        supportedLocales: ['en'],
        resourceUrl:
          process.env.NODE_ENV === 'development'
            ? '/strings/{locale}.json'
            : '/board-chat/strings/{locale}.json',
      }}
    >
      <PaymentsContextProvider>
        <App />
      </PaymentsContextProvider>
    </TrelloPowerUpContextProvider>
  </LoggerErrorBoundary>,
  document.getElementById('root')
);
